import { useMemo } from 'react'
import styled from 'styled-components'
import { Link, OutletWrapper, PageLevelTableWrapper } from '@base'
import { BoxWapper, ResponsiveLeft, ResponsiveRight, ResponsiveStepWrapper } from '@pages/Admin/Underwriting/ViewReport/FinalReport/styles'
import { strings } from '@constants'
import { Devices, Spacings } from '@styles'
import { FitnessCenter, Report, TrackChanges } from '@material-ui/icons'
import { paths } from '@routes'
import { Outlet, useLocation, useOutletContext } from 'react-router'
import { removeTrailingSlash } from '@utils'

const ResponsiveWrapper = styled.div`
	display: flex;
	flex-direction: row;
	padding: 0;
	width: 100%;
	justify-content: start;
	column-gap: ${Spacings.SPACING_2B};
	flex-wrap: wrap;
	padding-left: ${Spacings.SPACING_4B};
	top: ${Spacings.SPACING_13B};
	position: sticky;

	@media ${Devices.tablet} {
		flex-direction: column;
		width: 50%;
		padding-left: 0;
	}
	@media ${Devices.laptop} {
		flex-direction: column;
		width: 50%;
	}

	// @media ${Devices.mobile} {
	padding-bottom: ${Spacings.SPACING_4B};
	// }
`

const ResponsiveLeftWrapper = styled(ResponsiveLeft)`
	top: ${Spacings.SPACING_13B};
	z-index: 3;
	background-color: ${({ theme }) => theme.palette.background.blueLightest};
`

const DashboardReport = () => {
	const { pathname } = useLocation()
	const [forceUpdate, update] = useOutletContext()

	const _tabs = useMemo(() => {
		const currentPath = removeTrailingSlash(pathname)
		return [
			{
				label: strings('overall'),
				icon: <Report />,
				selected: currentPath === paths.admin_dashboard_reports_overall,
				href: paths.admin_dashboard_reports_overall,
			},
			{
				label: strings('target'),
				icon: <TrackChanges />,
				selected: currentPath === paths.admin_dashboard_reports_target,
				href: paths.admin_dashboard_reports_target,
			},
			{
				label: strings('pending', 'order'),
				icon: <FitnessCenter />,
				selected: currentPath === paths.admin_dashboard_reports_pending_order,
				href: paths.admin_dashboard_reports_pending_order,
			},
		]
	}, [pathname])

	return (
		<>
			<PageLevelTableWrapper>
				<ResponsiveStepWrapper>
					<ResponsiveLeftWrapper>
						<ResponsiveWrapper isMenu>
							{_tabs.map((_item, index) => {
								return (
									<Link href={_item?.href}>
										<BoxWapper isSelected={_item.selected} onClick={_item.onClick} key={index}>
											{_item?.icon}
											<p>{_item?.label}</p>
										</BoxWapper>
									</Link>
								)
							})}
						</ResponsiveWrapper>
					</ResponsiveLeftWrapper>
					<ResponsiveRight>
						<OutletWrapper>
							<Outlet context={[forceUpdate, update]} />
						</OutletWrapper>
					</ResponsiveRight>
				</ResponsiveStepWrapper>
			</PageLevelTableWrapper>
		</>
	)
}

export default DashboardReport
